import {GET_ME_FAIL, GET_ME_RESET, GET_ME_START, GET_ME_SUCCESS} from "./constants";
import {GetMeActions, GetMeState} from "./types";

const initialState: GetMeState = {
  loading: false,
  data: undefined,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: GetMeActions,
): GetMeState => {
  switch (action.type) {
    case GET_ME_START:
      return {
        ...initialState,
        loading: true,
      }
    case GET_ME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case GET_ME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    case GET_ME_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
